import React from 'react';
import ProviderAvatar from '../ProviderAvatar';
import ResubscribeModalSeatBased from '~/components/payment/seat-based/ResubscribeModalSeatBased';
import history from '#/history';

function CanceledProvider({ canceledProvider, accounts }: $TSFixMe) {
  const [open, setOpen] = React.useState<boolean>(false);

  /**
   * This method only charges setup fees when all of the following conditions are met:
   * - User only has access to a single account
   * - The account only has a single stripe customer
   * - The stripe customer only has a single subscription
   * - That subscription has status 'incomplete_expired'
   */
  const checkForIncompleteExpired = () => {
    let chargeSetupFee = false;

    if (accounts.length === 1 && accounts[0].stripe_customers.length === 1) {
      const stripeCustomer = accounts[0].stripe_customers[0];
      if (
        stripeCustomer.stripe_subscriptions.length === 1 &&
        stripeCustomer.stripe_subscriptions[0].status === 'incomplete_expired'
      ) {
        chargeSetupFee = true;
      }
    }

    if (chargeSetupFee) {
      history.push(
        `profiles/pay-for/${canceledProvider.id}?return_to_plan_management=1&prior_subscription_was_incomplete_expired=1`
      );
    } else {
      setOpen(true);
    }
  };

  return (
    <div className='account-box m-r-sm'>
      <ProviderAvatar provider={canceledProvider} />
      <button
        className='primary pill md'
        onClick={() => {
          checkForIncompleteExpired();
        }}
      >
        Reactivate Seat
      </button>
      <ResubscribeModalSeatBased
        provider={canceledProvider}
        open={open}
        toggle={setOpen}
        onSubmit={() => ({})}
        plan={<div className='flex column m-b-sm'></div>}
      />
    </div>
  );
}

export default CanceledProvider;
